import { IDENTITY_PROVIDERS } from '../consts';
export const isIdentityProvider = (value) => {
    return value ? Object.keys(IDENTITY_PROVIDERS).includes(value) : false;
};
